import beerManagerSlice from 'features/beersManager/slice';
import postGeneratorSlice from 'features/postGenerator/slice';
import beerStyleViewSlice from 'pages/beerStylesView/store/beerStyleViewSlice';
import beerPreviewSlice from 'pages/beersView/store/beerPreviewSlice';
import postArchiveSlice from 'pages/postArchive/store/postArchiveSlice';
import pubPageSlice from 'pages/pubPagesView/store/pubPageSlice';

import appSlice from './app/appSlice';
import beerSlice from './beers/beerSlice';
import beerStyleSlice from './beerStyles/beerStyleSlice';
import breweriesSlice from './breweries/breweriesSlice';
import filterSlice from './filter/filterSlice';
import headerSlice from './header/headerSlice';
import imageUploaderSlice from './imageUploader/imageUploaderSlice';
import managedPubSlice from './managedPub/managedPubSlice';
import modalSlice from './modal/modalSlice';
import pageEditorSlice from './pageEditors/pageEditorSlice';
import postsSlice from './posts/postsSlice';
import profileSlice from './profile/profileSlice';
import pubSlice from './pubs/pubSlice';
import singleBrewerySlice from './singleBrewery/singleBrewerySlice';
import singlePageEditorSlice from './singlePageEditor/singlePageEditorSlice';

const rootReducer = () => {
  return {
    app: appSlice.reducer,
    modal: modalSlice.reducer,
    profile: profileSlice.reducer,
    beerStyles: beerStyleSlice.reducer,
    beers: beerSlice.reducer,
    breweries: breweriesSlice.reducer,
    imageUploader: imageUploaderSlice.reducer,
    pubs: pubSlice.reducer,
    pageEditors: pageEditorSlice.reducer,
    header: headerSlice.reducer,
    filter: filterSlice.reducer,
    managedPub: managedPubSlice.reducer,
    postGenerator: postGeneratorSlice.reducer,
    beersManager: beerManagerSlice.reducer,
    // Preview Reducers
    singleBrewery: singleBrewerySlice.reducer,
    singlePageEditor: singlePageEditorSlice.reducer,
    pubPage: pubPageSlice.reducer,
    beerPreview: beerPreviewSlice.reducer,
    beerStyleView: beerStyleViewSlice.reducer,
    posts: postsSlice.reducer,
    postArchive: postArchiveSlice.reducer,
  };
};

export default rootReducer;
